import { render } from "./ExtensionKeyAllocation.vue?vue&type=template&id=4619b80c&scoped=true"
import script from "./ExtensionKeyAllocation.vue?vue&type=script&lang=js"
export * from "./ExtensionKeyAllocation.vue?vue&type=script&lang=js"

import "./ExtensionKeyAllocation.vue?vue&type=style&index=0&id=4619b80c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4619b80c"]])

export default __exports__